import { User } from "lucide-react";
import { cn } from "../../lib/cn";
import { Avatar, AvatarFallback, AvatarImage } from "../Avatar";

export interface AvatarCellProps {
  name: string;
  subtitle?: string | undefined;
  src?: string | undefined;
  className?: string | undefined;
}

export function AvatarCell({
  name,
  subtitle,
  src,
  className,
}: AvatarCellProps) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <Avatar className="size-8 shrink-0">
        {src ? <AvatarImage src={src} alt={name} /> : null}
        <AvatarFallback>
          <User className="size-4 text-secondary-icon" />
        </AvatarFallback>
      </Avatar>
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-body-m-r text-text">{name}</span>
        {subtitle ? (
          <span className="truncate text-body-footnote text-text-placeholder">
            {subtitle}
          </span>
        ) : null}
      </div>
    </div>
  );
}
